<template>
  <div class="myTable">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">用户 ID：</span>
            <el-input
              v-model="searchInfo.userId"
              clearable
              placeholder="精确匹配"
              @keyup.enter.native="search">
            </el-input>
          </div>
          <div class="search-item">
            <span class="label">设备 ID：</span>
            <el-input
              v-model="searchInfo.deviceId"
              clearable
              placeholder="模糊匹配"
              @keyup.enter.native="search">
            </el-input>
          </div>
          <div class="search-item">
            <span class="label">平台：</span>
            <el-select v-model="searchInfo.platform" clearable placeholder="全部" @change="search">
              <el-option label="Android" value="android"></el-option>
              <el-option label="iOS" value="ios"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">品牌：</span>
            <el-input
              v-model="searchInfo.deviceBrand"
              clearable
              placeholder="模糊匹配"
              @keyup.enter.native="search">
            </el-input>
          </div>
          <div class="search-item">
            <span class="label">型号：</span>
            <el-input
              v-model="searchInfo.deviceModel"
              clearable
              placeholder="模糊匹配"
              @keyup.enter.native="search">
            </el-input>
          </div>
          <div class="search-item">
            <span class="label">APP 版本：</span>
            <el-input
              v-model="searchInfo.versionName"
              clearable
              placeholder="模糊匹配"
              @keyup.enter.native="search">
            </el-input>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </div>
    </div>

    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="620px" border>
        <el-table-column type="index" width="50" label="#"></el-table-column>
        <el-table-column prop="id" label="ID" width="70"></el-table-column>
        <el-table-column prop="userId" label="用户 ID" width="90"></el-table-column>
        <el-table-column prop="deviceId" label="设备 ID" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="deviceBrand" label="品牌" width="100"></el-table-column>
        <el-table-column prop="deviceModel" label="型号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="platform" label="平台" width="90">
          <template slot-scope="scope">
            <el-tag :type="platformTagType(scope.row.platform)" size="small">
              {{ formatPlatform(scope.row.platform) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="versionName" label="APP 版本" width="100"></el-table-column>
        <el-table-column prop="city" label="城市" width="90"></el-table-column>
        <el-table-column prop="createTime" label="上报时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <el-empty :image-size="160"></el-empty>
        </template>
      </el-table>
      <el-pagination
        style="text-align: right; margin-top: 10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="searchInfo.pageNumber"
        :page-size="searchInfo.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="sizes, prev, pager, next, total"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog
      title="开机上报详情"
      :visible.sync="detailVisible"
      width="640px"
      custom-class="dev-stat-detail-dialog"
      append-to-body
      @close="detailRow = null">
      <div v-loading="detailLoading" v-if="detailRow" class="detail-form-wrap">
        <el-form label-width="100px" size="small" class="detail-form">
          <el-row>
            <el-col :span="12">
              <el-form-item label="ID：">{{ detailRow.id }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户 ID：">{{ detailRow.userId }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="设备 ID：" class="break-all">{{ detailRow.deviceId || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌：">{{ detailRow.deviceBrand || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="型号：">{{ detailRow.deviceModel || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="平台：">{{ formatPlatform(detailRow.platform) }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="系统描述：">{{ detailRow.osSystem || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="OS 名：">{{ detailRow.osName || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="OS 版本：">{{ detailRow.osVersion || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="APP 名称：">{{ detailRow.appName || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="版本名：">{{ detailRow.versionName || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="版本号：">{{ detailRow.versionCode || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分辨率：">{{ screenText(detailRow) }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="语言：">{{ detailRow.language || '--' }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="城市：">{{ detailRow.city || '--' }}</el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上报时间：">{{ formatTime(detailRow.createTime) }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { axios } from '../../config/axios';

  export default {
    name: 'dev-stat',
    data() {
      return {
        loading: false,
        detailLoading: false,
        tableData: [],
        total: 0,
        searchInfo: {
          userId: '',
          deviceId: '',
          platform: '',
          deviceBrand: '',
          deviceModel: '',
          versionName: '',
          pageNumber: 1,
          pageSize: 10,
        },
        detailVisible: false,
        detailRow: null,
      };
    },
    created() {
      this.pageInfo();
    },
    methods: {
      buildListParams() {
        const p = {
          pageNumber: this.searchInfo.pageNumber,
          pageSize: this.searchInfo.pageSize,
        };
        const uid = String(this.searchInfo.userId || '').trim();
        if (uid !== '') {
          const n = Number(uid);
          if (!Number.isNaN(n)) p.userId = n;
        }
        ['deviceId', 'platform', 'deviceBrand', 'deviceModel', 'versionName'].forEach(key => {
          const v = String(this.searchInfo[key] || '').trim();
          if (v !== '') p[key] = v;
        });
        return p;
      },
      search() {
        this.searchInfo.pageNumber = 1;
        this.pageInfo();
      },
      pageInfo() {
        if (this.loading) return;
        this.loading = true;
        axios.get('/appDeviceStartupLog/list', { params: this.buildListParams() }).then(res => {
          this.loading = false;
          if (res.code !== 200) {
            this.$message.error(res.message || '查询失败');
            return;
          }
          this.tableData = (res.data && res.data.list) || [];
          this.total = (res.data && res.data.total) || 0;
        }).catch(() => {
          this.loading = false;
        });
      },
      handleCurrentChange(val) {
        this.searchInfo.pageNumber = val;
        this.pageInfo();
      },
      handleSizeChange(val) {
        this.searchInfo.pageNumber = 1;
        this.searchInfo.pageSize = val;
        this.pageInfo();
      },
      openDetail(row) {
        this.detailVisible = true;
        this.detailRow = { ...row };
        this.detailLoading = true;
        axios.get(`/appDeviceStartupLog/${row.id}`).then(res => {
          this.detailLoading = false;
          if (res.code !== 200) {
            this.$message.error(res.message || '获取详情失败');
            return;
          }
          this.detailRow = res.data;
        }).catch(() => {
          this.detailLoading = false;
          this.$message.error('获取详情失败');
        });
      },
      formatPlatform(p) {
        if (!p) return '--';
        const s = String(p).toLowerCase();
        if (s === 'android') return 'Android';
        if (s === 'ios') return 'iOS';
        return p;
      },
      platformTagType(p) {
        const s = String(p || '').toLowerCase();
        if (s === 'android') return 'success';
        if (s === 'ios') return 'primary';
        return 'info';
      },
      formatTime(time) {
        if (!time) return '--';
        return String(time).replace('T', ' ').substring(0, 19);
      },
      screenText(row) {
        if (!row || (row.screenWidth == null && row.screenHeight == null)) return '--';
        return `${row.screenWidth || '-'} × ${row.screenHeight || '-'}`;
      },
    },
  };
</script>

<style lang="less" scoped>
  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          margin-right: 16px;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 150px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }
        }
      }
    }

    .search-btn {
      padding-bottom: 12px;
      white-space: nowrap;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 16px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    padding: 12px 16px 16px;
    border-radius: 4px;
  }

  .detail-form-wrap {
    min-height: 80px;
    box-sizing: border-box;
  }

  .detail-form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
    /deep/ .el-form-item__label {
      color: #606266;
    }
    /deep/ .el-form-item__content {
      color: #303133;
      word-break: break-word;
    }
  }

  .break-all {
    /deep/ .el-form-item__content {
      word-break: break-all;
    }
  }

</style>

<style lang="less">
  /* 弹窗挂到 body 后取消全局 .el-form 阴影等对只读详情不必要样式；收窄 padding 由组件 scoped 控制内容 */
  .dev-stat-detail-dialog.el-dialog .el-dialog__body {
    padding: 12px 20px 8px;
    box-sizing: border-box;
  }
</style>
